import { render, staticRenderFns } from "./AxButton.vue?vue&type=template&id=85fe8de6&scoped=true&"
import script from "./AxButton.vue?vue&type=script&lang=js&"
export * from "./AxButton.vue?vue&type=script&lang=js&"
import style0 from "./AxButton.vue?vue&type=style&index=0&id=85fe8de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe8de6",
  null
  
)

export default component.exports